import { forkJoin } from 'rxjs';
import { SectionHttpService } from 'src/app/http/section-http.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BranchHttpService } from '../http/branch-http.service';
import { HomePageHttpService } from '../http/home-page-http.service';

@Injectable({
    providedIn: 'root',
})
export class HomePageHttpResolverService implements Resolve<any> {
    constructor(private homePageHttpService: HomePageHttpService, private sectionHttpService: SectionHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const getHomePage = this.homePageHttpService.getHomePage();
        const getAllSections = this.sectionHttpService.getAllSections();
        return forkJoin([getHomePage, getAllSections]);
    }
}
